import { render } from "./WorkWeekAdmin.vue?vue&type=template&id=c650fa62"
import script from "./WorkWeekAdmin.vue?vue&type=script&lang=js"
export * from "./WorkWeekAdmin.vue?vue&type=script&lang=js"

import exportComponent from "/home/paperspace/thehrway-basic/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__